// ─── OOC DETECTION — one rule for every surface ──────────────────────────────
//
// Haley, 2026-10-29, in her Aspen DM: "Ooc: please no more repeats I keep
// getting versions of the same response". The DM surface recognised exactly
// one marker — the whole message wrapped in ((…)) — so that line was stored
// as an in-story message, the model answered it in character (it kept the
// scene going and repeated itself again), and the memory extractors read it
// as something that happened. Two more of Haley's and fifteen of Nicole's
// "ooc:" / "(ooc" lines sat in dm_messages the same way.
//
// director.js (channels) already treats ((…)), [OOC: …] and a line-leading
// "ooc:" / bare "ooc" as direction. This is the same vocabulary, applied to
// the WHOLE message for the DM and story composers. The text is stored as
// typed; only the is_ooc flag changes.

const OPEN_WRAP_RE = /^\(\(/;                        // ((…)) — an unclosed (( is still an aside
const BRACKET_RE = /^[[(]\s*ooc\b/i;                 // [ooc …]  [OOC: …]  (ooc) …
const PREFIX_RE = /^ooc\s*(?:[:\-—–]|\s)/i;          // ooc: …   OOC - …   ooc do a timeskip
const SLASHES_RE = /^\/\/\s*\S/;                     // // meta line (the RP convention)

/**
 * True when a composed message is an out-of-character aside rather than a
 * line in the story. Whole-message test: the marker must open the message.
 * @param {string} text
 */
export function isOOCMessage(text) {
  const t = String(text ?? '').trim();
  if (!t) return false;
  return OPEN_WRAP_RE.test(t) || BRACKET_RE.test(t) || PREFIX_RE.test(t) || SLASHES_RE.test(t);
}

/**
 * The Postgres twin of isOOCMessage (\\y is Postgres's word boundary), for
 * one-off repairs of rows stored before the rule was widened; a test holds the
 * two in step by running the SQL pattern as a JS regex with \\y → \\b.
 */
export const OOC_MARKER_SQL_RE = String.raw`^\s*(\(\(|[[(]\s*ooc\y|ooc\s*[:\-—–]|ooc\s+\S|//\s*\S)`;
